import { create } from "zustand";

const usefbStore = create((set) => ({

    adminName: "admin",
    userID: null,
    screenCount: null,
    authStatus: "loading",
    userName: null,
    accountPoints: null,
    solaraTokens:0,
    hasTasks: false,
    taskArray: [],
    userEmail:"",
    screeningActive: null,
    userScore: 0,
    accountBalance: 0,
    screeningTest: false,
    transactions: [],
    jobsArray: [],
    taskCooldownUntil: null,     
    inCooldown: false,           
    lastTaskBatchCompletedAt: null, 
    accountVerified:null,
    isReverified:null,
    secApproval:false,
    earningsPercentage:{
    percentage: 0,
    isPositive: true,
    isNegative: false,
    value: 0,
    paymentMethodSet:null,
    bankDetails:{},
    cryptoDetails:{},
    withdrawRequests: [],
    paymentMethod:null,
   
    },
    realName:"",
    region:"",
    paypalDetails:"",
    activeSince:"",
    jobApplications: [],
    totalTaskTaken:0,
    slctdTransID:null,
    emailList:[],
    
 

    setSecApproval: (sa) => set({ secApproval: sa }),
    setIsReverified: (iv) => set({ isReverified: iv }),
    setEmailList: (em) => set({ emailList: em }),
    setRealName: (rn) => set({ realName: rn }),
    setTransID: (td) => set({ slctdTransID: td }),
    setRegion: (rg) => set({ region: rg }),
    setActiveSince: (as) => set({ activeSince: as }),
    setAdminName: (name) => set({ adminName: name }),
    setJobApplications: (jobs) => set({ jobApplications: jobs }),
    setWithdrawRequests: (wr) => set({ withdrawRequests: wr }),
    setSetPaymentMethod: (pms) => set({ paymentMethodSet: pms }),
    setPaymentMethod: (pm) => set({ paymentMethod: pm }),
    setBankDetails: (bd) => set({ bankDetails: bd }),
    setPaypalDetails: (pd) => set({ paypalDetails: pd }),
    setCryptoDetails: (cd) => set({ cryptoDetails: cd }),
    setTotalTasksAllTime: (tt) => set({ totalTaskTaken: tt }),
    setEarningsPercentage: (data) => set({ earningsPercentage: data }),
    setJobArray: (ja) => set({ jobArray: ja }),
    setSolaraTokens: (st) => set({ solaraTokens: st }),
    setUserEmail: (em) => set({ userEmail: em }),
    setTransactions: (t) => set({ transactions: t }),
    setUserID: (uid) => set({ userID: uid }),
    setScreeningActive: (a) => set({ screeningActive: a }),
    setAuthenticated: () => set({ authStatus: "authenticated" }),
    setUnAuthenticated: () => set({ authStatus: "unauthenticated" }),
    setUserName: (uname) => set({ userName: uname }),
    setScreenCount: (sc) => set({ screenCount: sc }),
    setAccountPoints: (al) => set({ accountPoints: al }),
    setHasTasks: (ht) => set({ hasTasks: ht }),
    removeHasTasks: () => set({ hasTasks: false }),
    setTaskArray: (array) => set({ taskArray: array }),
    setAccountBalance: (ab) => set({ accountBalance: ab }),
    setScreeningTest: (st) => set({ screeningTest: st }),
    setUserScore: (score) => set({ userScore: score }),
    setAccountVerified: (av) => set({ accountVerified: av }),
    
    // ✅ NEW: Cooldown setters
    setTaskCooldownUntil: (cooldownUntil) => set({ 
        taskCooldownUntil: cooldownUntil,
        inCooldown: cooldownUntil ? new Date(cooldownUntil) > new Date() : false
    }),
    resetCooldown: () => set({ 
        taskCooldownUntil: null, 
        inCooldown: false,
        lastTaskBatchCompletedAt: null 
    }),
}));

export default usefbStore;